import type { FC, PropsWithChildren } from 'react';
import { Drawer as RootDrawer, IconButton } from '@mui/material';
import ErrorBoundary from '../ErrorBoundary';
import { CloseIcon } from '../icons';

export type DrawerProps = PropsWithChildren<{
    anchor?: 'left' | 'top' | 'right' | 'bottom';
    onClose?: () => void;
    hideCloseButton?: boolean;
    open?: boolean;
}>;

export const Drawer: FC<DrawerProps> = ({
    anchor = 'right',
    onClose,
    open,
    hideCloseButton,
    children,
}) => {
    return (
        <RootDrawer anchor={anchor} open={open} onClose={onClose}>
            {onClose && !hideCloseButton && (
                <IconButton
                    onClick={onClose}
                    size="large"
                    sx={{ position: 'absolute', top: 0, right: 0 }}
                >
                    <CloseIcon size={16} />
                </IconButton>
            )}
            <ErrorBoundary>{children}</ErrorBoundary>
        </RootDrawer>
    );
};
